import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/health-care-room";

export const pagingHealthCareRoom = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);
export const pagingHealthCareRoomByUser = (searchObject) =>
    axios.post(API_PATH + "/search-by-page-check-user", searchObject);

export const getHealthCareRoomById = (healthCareRoomId) => axios.get(API_PATH + "/getbyid/" + healthCareRoomId);

export const saveOrUpdateHealthCareRoom = healthCareRoom => axios.post(API_PATH + '/save', healthCareRoom);

export const deleteHealthCareRoom = healthCareRoomId => axios.delete(API_PATH + '/mark-delete/' + healthCareRoomId);

export const getHealthCareRoomByCurrentUser = () => axios.get(API_PATH + '/getRoomByCurrentUser');

export const getStaffRoomByCurrentUser = () => axios.get(API_PATH + '/get-staff-room-by-current-user');
export const getDefaultRoomByCurrentUser = () => axios.get(API_PATH + '/get-default-room-by-current-user');
export const getDepartmentByCurrentUser = () => axios.get(API_PATH + "/get-staff-department-by-current-user")
export const getAllHealthCareRoom = () => axios.get(API_PATH + "/get-all-dto")
export const getAllHealthCareRoomByType = (type) => axios.get(API_PATH + "/get-all-health-care-room-by-type/" + type);

// lấy phòng mặc định
export const getDefaultRoomByTypeMap = () => axios.get(API_PATH + "/get-default-room-by-type-map");
export const pagingHealthCareRoomCheckUser = (searchObject) => axios.post(API_PATH + "/search-by-page-check-user", searchObject);


